import { Button, Modal, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import { useReferralFTUXModalStore } from "./ReferralFTUXModal"
import { useReferralModalStore } from "./ReferralModal"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"

interface ThoughtfulModalStoreProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useThoughtfulModalStore = create<ThoughtfulModalStoreProps>(
  (set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  })
)

const ThoughtfulModal = ({
  onShareGuestPass,
}: {
  onShareGuestPass: () => void
}) => {
  const { isOpen, onClose } = useThoughtfulModalStore()
  const { onClose: onCloseReferralModal } = useReferralModalStore()
  const { onClose: onCloseReferralFTUXModal } = useReferralFTUXModalStore()
  const { t } = useTranslation()

  const handleClose = () => {
    onClose()
    onCloseReferralModal()
    onCloseReferralFTUXModal()
  }

  const onShareMoreClick = () => {
    trackAnalyticEvent(ANALYTIC_EVENTS.SHARE_MORE_CLICK)
    onClose()
    onShareGuestPass()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} animate displayCloseIcon>
      <div className="flex flex-col w-[350px] items-center">
        <div className="flex flex-col gap-4 items-center px-6 py-4">
          <img
            src="/images/heart-face.gif"
            alt="Heart face"
            className="w-16 h-16"
          />
          <div className="flex flex-col items-center">
            <Typography variant="h3">
              {t("REFERRAL_THOUGHTFUL_TITLE")}
            </Typography>
          </div>
          <Typography variant="body">
            {t("REFERRAL_THOUGHTFUL_DESC")}
          </Typography>
        </div>
        <div className="flex justify-center items-center w-full px-6 py-4">
          <Button
            text={t("REFERRAL_THOUGHTFUL_SHARE_MORE")}
            onClick={onShareMoreClick}
            fullWidth
          />
        </div>
      </div>
    </Modal>
  )
}

export default ThoughtfulModal
